import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import FormikTextField from '../../../../shared/components/formik/FormikTextField'
import FormikNumericField from '../../../../shared/components/formik/FormikNumericField'

const PortMappingForm = ({ portMapping, createPortMapping, updatePortMapping, onSuccess, onCancel }) => {
  const intl = useIntl()
  const isEditMode = Boolean(portMapping)

  const validationSchema = Yup.object({
    name: Yup.string(),
    sourcePort: Yup.number().required(intl.formatMessage({ id: 'login.error.required' })),
    targetHost: Yup.string(),
    targetPort: Yup.number().required(intl.formatMessage({ id: 'login.error.required' }))
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: portMapping?.name || '',
      sourcePort: portMapping?.sourcePort || '',
      targetHost: portMapping?.targetHost || 'localhost',
      targetPort: portMapping?.targetPort || ''
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      const portMappingData = {
        servicePortMapping: {
          name: values.name || null,
          sourcePort: values.sourcePort,
          targetHost: values.targetHost,
          targetPort: values.targetPort
        }
      }

      const apiCall = isEditMode
        ? updatePortMapping(portMapping.id, portMappingData)
        : createPortMapping(portMappingData)

      apiCall
        .then(() => {
          onSuccess()
        })
        .catch((err) => {
          setStatus(err.message || 'Error saving port mapping')
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  })

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormikTextField
        formik={formik}
        name="name"
        label={<FormattedMessage id="portMappings.form.nameLabel" />}
        autoFocus
      />

      <Box sx={{ mt: 2 }}>
        <FormikNumericField
          formik={formik}
          name="sourcePort"
          label={<FormattedMessage id="portMappings.form.sourcePortLabel" />}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <FormikTextField
          formik={formik}
          name="targetHost"
          label={<FormattedMessage id="portMappings.form.targetHostLabel" />}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <FormikNumericField
          formik={formik}
          name="targetPort"
          label={<FormattedMessage id="portMappings.form.targetPortLabel" />}
        />
      </Box>

      {formik.status && (
        <Typography color="error" sx={{ mt: 2 }}>
          {formik.status}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="portMappings.form.submitButton" />
        </Button>
      </Box>
    </Box>
  )
}

export default PortMappingForm
